import { AppUrls } from '@/urls';
import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalBody } from 'reactstrap';
import TermsAndConditionsContent from '../TermsAndConditionsContent';

const Space = () => <div style={{ height: 10 }} />;
export default function TermsAndConditionsModal({ onClose }: { onClose: () => void }) {
  return (
    <Modal isOpen={true} unmountOnClose={true} size="xl">
      <ModalBody>
        <div className="text-20 fw-500  text-blue-1 mb-20 text-center">
          NTA Terms and Conditions for Online Reservations for Hotels and Activities
        </div>

        <div style={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}>
          <TermsAndConditionsContent />
        </div>

        <div className="row  pt-20 mt-10 ">
          <div className="col d-flex items-center">
            <Link to={AppUrls.Login} className="text-blue-1">
              Back to login page
            </Link>
          </div>
          <div className="col-auto">
            <button type="button" className="button py-10 -dark-1 bg-blue-1 text-white px-20" onClick={onClose}>
              I agree with Terms & Conditions <div className="icon-arrow-top-right ml-15" />
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
